const IS_DEV = process.env.NODE_ENV !== "production";

const logger = {
  error: (...args) => { if (IS_DEV) console.error(...args); },
  warn: (...args) => { if (IS_DEV) console.warn(...args); },
  info: (...args) => { if (IS_DEV) console.info(...args); },
};

export default logger;
